module.exports = __webpack_public_path__ + "img/values-collaboration.472e6419.gif";